import Swiper, { Pagination, Navigation } from 'swiper';
import { initCopyTexts } from "Functions/copy-text";
import { Vue, i18n } from 'Common/vue';

import '../layouts/default';

import '../ui/slider';
import '../ui/tabs';
import '../common/lightgallery';
import '../common/anchor';
import '../common/wishlist';
import '../common/loyalty-small-box';

import PriceOfferModal from '../components/vue/priceOffer/PriceOfferModal.vue';

initCopyTexts();

Swiper.use([Pagination, Navigation]);

const priceOfferModalElem = document.querySelector('#priceOfferModal');

if (priceOfferModalElem) {
    window.$_priceOfferModal = new Vue({
        i18n,
        render: h => h(PriceOfferModal, {
            props: {
                productId: parseInt(priceOfferModalElem.dataset.productId, 10)
            }
        })
    }).$mount(priceOfferModalElem);

    document.querySelectorAll('.js-price-offer-trigger').forEach(trigger => {
        trigger.addEventListener('click', event => {
            event.preventDefault();

            rEvent.dispatch('PriceOffer.open');
        });
    });
}

document.addEventListener('DOMContentLoaded', function() {
    if (document.querySelector('.c-set-tabs')) {
        function checkSetTabsArrow() {
            const arrow = document.querySelector('.js-set-tabs-arrow'),
                navHolder = document.querySelector('.js-set-tabs-nav'),
                navHolderInfo = navHolder.getBoundingClientRect(),
                lastElem = navHolder.querySelector('.c-set-tabs__trigger:last-child'),
                lastElemInfo = lastElem.getBoundingClientRect();

            arrow.classList.toggle('is-hidden', lastElem.offsetLeft + lastElemInfo.width <= navHolderInfo.width);
        }

        checkSetTabsArrow();

        document.querySelector('.js-set-tabs-nav').addEventListener('scroll', function() {
            checkSetTabsArrow();
        });

        document.querySelectorAll('.c-set-tabs__trigger').forEach(trigger => {
            trigger.addEventListener('click', function() {
                const navHolder = document.querySelector('.js-set-tabs-nav');

                navHolder.scroll({
                    left: trigger.offsetLeft,
                    behavior: 'smooth'
                });
            });
        });

        document.querySelector('.js-set-tabs-arrow').addEventListener('click', () => {
            const navHolder = document.querySelector('.js-set-tabs-nav'),
                elemInfo = navHolder.querySelector('.c-set-tabs__trigger:last-child').getBoundingClientRect(),
                navHolderInfo = navHolder.getBoundingClientRect();

            if (navHolder.querySelector('.c-set-tabs__trigger.is-active').nextElementSibling) {
                navHolder.querySelector('.c-set-tabs__trigger.is-active').nextElementSibling.click();
            } else {
                navHolder.querySelector('.c-set-tabs__trigger:first-child').click();
            }
        });

        window.rEvent.on('Window.resized', () => {
            checkSetTabsArrow();
        });
    }
});